export default () => ({

	img: {
		height: '20rem',
		marginTop: '2rem',
	},
	// Start Media Queries
	'@media (min-width: 1024px)': {
		div: {
			width: '60%',
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			background: '#000',
		},
		img: {
			height: '80%',
		},
	},
});
